<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='"padding-bottom:200px;"' class="container " >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row" >
                <template #default>   </template>
                </m-div><m-h1 v-bind='{...{},...{}}' :style='"border-radius:30px"' class="text-center shadow m-4 p-4" >
                <template #default>طرح اقساط کلینیک اولند   </template>
                </m-h1><m-h4 v-bind='{...{},...{}}' :style='""' class="text-center" >
                <template #default>ما برای راحتی شما تصمیم گرفتیم که شرایط اقساط رو برای استفاده از خدمات و خرید از انلاین شاپ اولند فراهم کنیم.امیدواریم بتوانیم قدم کوچکی را به سمت شادی شما سهیم بشیم   </template>
                </m-h4><m-img v-bind='{...{"src":"https:\/\/api.olandclinic.ir\/storage\/contents\/A08BC04C-93A0-4A49-BE88-BEA58B0F852B.png.jpeg","alt":"oland"},...{}}' :style='"height:900px;\nobject-fit:contain;"' class="img-fluid mx-auto col-12" ></m-img></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mH1 from '@moeinmdn/miw-alpha-components/src/package/Tags/H1'; import mH4 from '@moeinmdn/miw-alpha-components/src/package/Tags/H4'; import mImg from '@moeinmdn/miw-alpha-components/src/package/Tags/Img';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mH1,mH4,mImg },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
